import { ICellRendererParams } from "ag-grid-community";

import type { RequestRow } from "../requestLogGridTypes";

import { HydrationPendingCell, isRequestRowHydrating } from "./HydrationPendingCell";
import { renderHighlightedPreview } from "./renderHighlightedPreview";
import { ScrollablePreviewCell } from "./ScrollablePreviewCell";

export const ResponsePreviewCellRenderer = ({ data }: ICellRendererParams<RequestRow>) => {
  const preview = data?.request_response_preview;

  if (isRequestRowHydrating(data) && !preview) {
    return <HydrationPendingCell />;
  }

  if (!preview) {
    return <span className="text-gray-400">-</span>;
  }

  return (
    <ScrollablePreviewCell>
      {/<em>/i.test(preview)
        ? renderHighlightedPreview(preview, data?.request_response_preview_highlight_annotations)
        : preview}
    </ScrollablePreviewCell>
  );
};
